import { render, staticRenderFns } from "./CardSetPointItemTable.vue?vue&type=template&id=6b16621e&scoped=true&"
import script from "./CardSetPointItemTable.vue?vue&type=script&lang=js&"
export * from "./CardSetPointItemTable.vue?vue&type=script&lang=js&"
import style0 from "./CardSetPointItemTable.vue?vue&type=style&index=0&id=6b16621e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b16621e",
  null
  
)

export default component.exports